import { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import "../App.css";

import Services from './Services'
import 'react-confirm-alert/src/react-confirm-alert.css';
import Popup from 'reactjs-popup';

import 'reactjs-popup/dist/index.css';
import { RotatingLines } from "react-loader-spinner";

import { ImageList } from "@material-ui/core";

import * as AiIcons from 'react-icons/ai';

import { MDBCol, MDBRow, MDBCard, MDBCardText, MDBCardBody, MDBTypography } from 'mdb-react-ui-kit';
import Form from 'react-bootstrap/Form'

import { Card } from "reactstrap";
import Pagination from "rc-pagination";
import "./pagination.css";

const moment = require("moment");

const EmployeeWorkDetails = () => {


    var today = moment(new Date(), "DD/MM/YYYY").toDate();
    var priorDate = new Date(new Date(today).setDate(today.getDate() - 30));

    const [hospitaltype, sethospitaltype] = useState([]);
    const [hospitalcode, sethospitalcode] = useState([]);
    const [staffdata, setStaffdata] = useState([]);

    const [masterdata, setmasterdata] = useState({
        hospital_type: sessionStorage.getItem('login_hospital_type'),
        hospital_code: sessionStorage.getItem('login_hospital_code'),
        login_staff_details: "",
        f_fromdate: priorDate.toISOString().slice(0, 10),
        f_todate: today.toISOString().slice(0, 10)
    });

    const [staffuniqueid, setStaffuniqueid] = useState("");
    const [pnumchars, setpnumchars] = useState("");
    const [login_work_place, setlogin_work_place] = useState("");
    const [login_staff_display_nm, setlogin_staff_display_nm] = useState("");
    const [login_login_user_nm, setlogin_login_user_nm] = useState("");
    const [login_staff_mobile_nu, setlogin_staff_mobile_nu] = useState("");
    const [login_staff_aadharno, setlogin_staff_aadharno] = useState("");

    const [loading, setLoading] = useState(false);

    const [attendancedata, setattendancedata] = useState([]);
    const [workupdatedata, setWorkupdatedata] = useState([]);

    const [deliverypatients, setDeliveryPatients] = useState([]);
    const [dischargedpatients, setDischargedPatients] = useState([]);

    const [dateList, setDateList] = useState([]);

    function handleChangeHospitaltypes(event, frm) {

        setattendancedata([]);
        setWorkupdatedata([]);
        setDeliveryPatients([]);
        setDischargedPatients([]);
        closeleadsfromdata();

        if (frm === "hspttype") {
            masterdata.hospital_code = "";
            masterdata.login_staff_details = "";
        } else if (frm === "hsptcode") {
            masterdata.login_staff_details = "";
        }
        const { name, value } = event.target;
        setmasterdata({ ...masterdata, [name]: value });
    }


    useEffect(() => {
        try {
            if (masterdata && typeof masterdata.login_staff_details === 'string') {
                let splitdata = masterdata.login_staff_details.split("/");
                if (splitdata[0] !== "") {
                    setlogin_work_place(splitdata[0]);
                }
                if (splitdata[1] !== "") {
                    setlogin_staff_display_nm(splitdata[1]);
                }
                if (splitdata[2] !== "") {
                    setlogin_login_user_nm(splitdata[2]);
                }
                if (splitdata[3] !== "") {
                    setlogin_staff_mobile_nu(splitdata[3]);
                }
                if (splitdata[4] !== "") {
                    setlogin_staff_aadharno(splitdata[4]);
                }
            } else {
                console.error("login_staff_details is not a valid string. ", masterdata.login_staff_details);
            }


            if (login_login_user_nm && typeof login_login_user_nm === 'string') {
                setStaffuniqueid(login_login_user_nm.replace(/.{2}$/, "**"))
            } else {
                console.error('login_login_user_nm is undefined or not a string:', login_login_user_nm);
            }


            if (login_staff_mobile_nu && typeof login_staff_mobile_nu === 'string') {
                let pnumchars = "";
                const numchars = login_staff_mobile_nu.split('');
                for (let i = 0; i < numchars.length; i++) {
                    pnumchars = pnumchars + "*"
                    i++;
                    pnumchars = pnumchars + numchars[i]
                }
                setpnumchars(pnumchars)
            } else {
                console.error('login_staff_mobile_nu is undefined or not a string:', login_staff_mobile_nu);
            }

            getHospitalTypes();

            const hospitalcode = [{ hospitaltype_name: 'DME', hospitalcode_name: 'GMH-TPT' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'MCH-VJA' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'RIMS-ONG' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'RIMS-SKLM' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'RIMS-KDP' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'GVH-VSKP' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'KGH-VSKP' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'GGH-GTR' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'GGH-KKD' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'GGH-ATP' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'MCHSPSR-NLR' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'GGH-KNL' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'DH-NDL' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'DH-MTM' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'DH-RJY' },
            { hospitaltype_name: 'DME', hospitalcode_name: 'MCH-ELR' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'DH-HPUR' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'DH-TNL' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'DH-PDTR' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'DH-AKP' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'MCH-ONG' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'MCH-VZG' },
            { hospitaltype_name: 'VVP', hospitalcode_name: 'MCH-ADONI' }];

            const filtered = hospitalcode.filter(hospitalcode => {
                return hospitalcode.hospitaltype_name === masterdata.hospital_type;
            });

            sethospitalcode(filtered);

        } catch (e) {
            console.log(e);
        }
    }, [masterdata.hospital_type, masterdata.login_staff_details, login_login_user_nm, login_staff_mobile_nu]);

    const getHospitalTypes = async () => {
        try {
            const hospitaltype = [{ hospitaltype_name: 'DME' }, { hospitaltype_name: 'VVP' }];
            sethospitaltype(hospitaltype);

        } catch (e) {
            console.log(e);
        }
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const generateDateList = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const dates = [];

        // Ensure the start date is before the end date
        if (startDate > endDate) {
            alert("Start date must be before end date.");
            return [];
        }

        let currentDate = startDate;
        while (currentDate <= endDate) {
            dates.push({ dateval: formatDate(new Date(currentDate)) }); // Push formatted date as an object
            currentDate.setDate(currentDate.getDate() + 1); // Increment the date by 1
        }

        return dates;
    };



    useEffect(() => {

        if (!masterdata.hospital_type?.trim()) {
            //alert("Select Hospital Type");
        } else if (!masterdata.hospital_code?.trim()) {
            //alert("Select Hospital Code");
        } else {

            setStaffdata([]);

            let filterquary = {
                hospital_type: masterdata.hospital_type,
                hospital_code: masterdata.hospital_code,
            };
            Services.getStafflistdata(filterquary).then((res) => {
                if (res.status === 200) {
                    const staffdata = res.data.staffdata;

                    const filtered = staffdata.filter(staffdata => {
                        return staffdata.staff_status === "Active";
                    });
                    setStaffdata(filtered);
                } else Promise.reject();
            }).catch((error) => {
                setStaffdata([]);
            });

        }
    }, [masterdata.hospital_type, masterdata.hospital_code]);


    const getData = () => {

        if (validateForm()) {

            const dates = generateDateList(masterdata.f_fromdate, masterdata.f_todate);
            setDateList(dates);
            setLoading(true);
            setdlCurrent(1);

            if (login_staff_mobile_nu !== "" && login_staff_aadharno !== "") {
                Services.empGetuniquenumber(login_staff_mobile_nu, login_staff_aadharno).then((res) => {
                    if (res.status === 200) {
                        const fattendance = res.data.data;
                        if (fattendance.length > 0) {
                            const lastAttendance = fattendance[fattendance.length - 1];
                            const uniqueNu = lastAttendance.emp_unique_nu?.trim() || "";
                            if (uniqueNu !== "") {
                                getWorkupdatesData(uniqueNu);
                            }
                        } else {
                            alert("Employee not found");
                        }
                    } else {
                        return Promise.reject(new Error("Failed to fetch attendance data"));
                    }
                }).catch((error) => {
                    alert("Error fetching attendance data:", error);
                });
            }

            const fromDate = moment(masterdata.f_fromdate).format("DD-MM-YYYY");
            const toDate = moment(masterdata.f_todate).format("DD-MM-YYYY");

            Services.getEmpEntryPatientsdata(masterdata.hospital_type, masterdata.hospital_code, login_login_user_nm, fromDate, toDate).then((res) => {
                if (res.status === 200) {

                    console.log(res.data)
                    console.log(masterdata.hospital_type + "-" + masterdata.hospital_code + "-" + login_login_user_nm + "-" + fromDate);

                    const dlpatients = res.data.createdpatients;
                    const dspatients = res.data.dischargedpatients;
                    const dlfiltered = dlpatients.slice().reverse();
                    const dsfiltered = dspatients.slice().reverse();

                    setDeliveryPatients(dlfiltered);
                    setDischargedPatients(dsfiltered);

                    if (dlfiltered.length === 0) {
                        alert("Empty data");
                        setLoading(false);
                    }
                    setLoading(false);

                } else Promise.reject();
            }).catch((error) => {
                alert("Something went wrong(" + error + ")");
            });
        }
    }

    const getWorkupdatesData = (user_unique_nu) => {

        setattendancedata([]);
        setWorkupdatedata([]);

        const fromDate = moment(masterdata.f_fromdate).format("DD-MM-YYYY");
        const toDate = moment(masterdata.f_todate).format("DD-MM-YYYY");

        let filterquary = {
            from_dt: fromDate,
            to_dt: toDate,
            emp_unique_nu: user_unique_nu,
        };

        Services.empGetAttendanceWorkupdate(filterquary).then((res) => {
            if (res.status === 200) {
                const attendancedata = res.data.data.attendance;
                const workupdatedata = res.data.data.workStatus;
                setattendancedata(attendancedata);
                setWorkupdatedata(workupdatedata);
            } else Promise.reject();
        }).catch((error) => {
            alert("Something went wrong(" + error + ")");
            setattendancedata([]);
            setWorkupdatedata([]);
        });


    }

    const validateForm = (e) => {

        let formIsValid = true;
        if (!masterdata.hospital_type?.trim()) {
            alert("Select Hospital Type");
            formIsValid = false;
        } else if (!masterdata.hospital_code?.trim()) {
            alert("Select Hospital Code");
            formIsValid = false;
        } else if (!masterdata.login_staff_details?.trim()) {
            alert("Select Employee name");
            formIsValid = false;
        } else if (!masterdata.f_fromdate?.trim()) {
            alert("Please select from date.");
            formIsValid = false;
        } else if (!masterdata.f_todate?.trim()) {
            alert("Please select to date.");
            formIsValid = false;
        } else if (moment(masterdata.f_fromdate).isAfter(moment(masterdata.f_todate))) {
            alert("'From date' must be less than or equals to 'To date'");
            formIsValid = false;
        }

        return formIsValid;
    }





    const JoiningPatients = ({ patientsdata, report_dateval, report_type }) => {
        if (report_type === "deliveries") {
            return renderReportCount(patientsdata, report_dateval, report_type, "patient_created_by_date");
        } else if (report_type === "discharges") {
            return renderReportCount(patientsdata, report_dateval, report_type, "patient_discharged_by_date");
        }
    };


    const renderReportCount = (patientsdata, report_dateval, report_type, filterKey) => {
        const datesval = patientsdata.filter(dlcurrent =>
            dlcurrent[filterKey] === report_dateval
        ).map(dlcurrent => dlcurrent[filterKey]);

        const count = datesval.length;
        const color = count === 0 ? "black" : "#007bff";
        const content = (
            <b style={{ color, marginRight: "5px", marginLeft: "5px", cursor: count > 0 ? "pointer" : "default" }}
                onClick={count > 0 ? (e) => openleadsfromdata(patientsdata, report_dateval, report_type) : undefined}>
                {count > 0 ? <u>{count}</u> : count}
            </b>
        );
        return (
            <MDBCardText className="d-flex fw-normal mt-1 mb-0 small" style={{ width: "100%" }}>
                {content}
            </MDBCardText>
        );
    };

    const [leadsfromdataView, setLeadsfromdataView] = useState("NO");
    const [leadfromlistloading, setLeadfromlistLoading] = useState(false);
    const [dashboardLeadfromLeads, setDashboardLeadfromLeads] = useState([]);

    const openleadsfromdata = (deliverypatients, report_dateval, report_type) => {
        setLeadsfromdataView("YES");
        getDashboardLeadsfromdata(deliverypatients, report_dateval, report_type);
    }

    const closeleadsfromdata = () => {
        setLeadsfromdataView("NO");
        setLeadfromlistLoading(false);
        setDashboardLeadfromLeads([]);

    }

    const getDashboardLeadsfromdata = async (LeadFromwisedayitem, report_dateval, report_type) => {
        setLeadfromlistLoading(true);
        setDashboardLeadfromLeads([]);

        var leadfromwisedatewisedata = [];
        for (let j = 0; j < LeadFromwisedayitem.length; j++) {
            if (report_type === "deliveries") {
                if (LeadFromwisedayitem[j].patient_created_by_date === report_dateval) {
                    leadfromwisedatewisedata.push(LeadFromwisedayitem[j]);
                }
            } else if (report_type === "discharges") {
                if (LeadFromwisedayitem[j].patient_discharged_by_date === report_dateval) {
                    leadfromwisedatewisedata.push(LeadFromwisedayitem[j]);
                }
            }
            if (LeadFromwisedayitem.length === j + 1) {
                setDashboardLeadfromLeads(leadfromwisedatewisedata);
                setLeadfromlistLoading(false);
            }
        }
    }

    const [dlsize, dlsetSize] = useState(15);  // Initial page size
    const [dlcurrent, setdlCurrent] = useState(1);

    // Function to get current page data
    const dlcurrentData = (current, pageSize) => {
        return dashboardLeadfromLeads.slice((current - 1) * pageSize, current * pageSize);
    };

    // Handle page change
    const dlPaginationChange = (page, pageSize) => {
        setdlCurrent(page);
        dlsetSize(pageSize);
    };

    // Optional: Custom arrows for previous/next
    const dlPrevNextArrow = (current, type, originalElement) => {
        if (type === 'prev') {
            return <button><i className="fa fa-angle-double-left" /></button>;
        }
        if (type === 'next') {
            return <button><i className="fa fa-angle-double-right" /></button>;
        }
        return originalElement;
    };

    const DashboardBranchwiseLeadsfromData = () => {
        const renderPatientStatus = (status) => {
            const color = status === "IN HOSPITAL" ? "green" : "red";
            return <b style={{ color }}>{status}</b>;
        };

        return (
            <div className="start_center" style={{ width: "100%", marginTop: "5px", flexDirection: "column" }}>
                <div className="end_center" style={{ width: "100%", padding: "10px", fontWeight: "bold" }}>
                    <AiIcons.AiFillCloseSquare
                        onClick={closeleadsfromdata}
                        style={{ color: "red", height: "25px", width: "25px", cursor: "pointer" }}
                    />
                </div>

                {leadfromlistloading ? (
                    <div className="center_center" style={{ width: "100%", display: "flex" }}>
                        <RotatingLines
                            width="50px"
                            height="50px"
                            strokeColor="red"
                            strokeWidth="5"
                            animationDuration="0.75"
                            visible={true}
                        />
                    </div>
                ) : (
                    <Card style={{ background: "#b3e5fc", borderRadius: "10px", width: "100%" }}>
                        <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                            <h1 style={{ marginLeft: "10px", fontSize: "14px", fontWeight: "bold", color: "red" }}>
                                Patient Full details: {dashboardLeadfromLeads.length}
                            </h1>

                            <Table striped bordered hover style={{ fontSize: "12px" }}>
                                <thead style={{ background: "lightsteelblue", color: "black" }}>
                                    <tr>
                                        <th>SNo</th>
                                        <th>Id</th>
                                        <th>Patient Name</th>
                                        <th>RCH ID</th>
                                        <th>Delivery date</th>
                                        <th>Delivery Entry Date</th>
                                        <th>Discharged</th>
                                        <th>Discharge Entry Date</th>
                                        <th>Status</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dlcurrentData(dlcurrent, dlsize).map((patient, index) => (
                                        <tr key={index}>
                                            <td>{(dlcurrent - 1) * dlsize + index + 1}</td>
                                            <td>{patient.patient_id}</td>
                                            <td>{patient.patient_name}</td>
                                            <td>{patient.patient_rchid} {patient.patient_ipnumber}</td>
                                            <td>{patient.record_created_date}</td>
                                            <td>{patient.patient_created_by_date} {patient.patient_created_by_time}</td>
                                            <td>{patient.patient_discharged_date}</td>
                                            <td>{patient.patient_discharged_by_date} {patient.patient_discharged_by_time}</td>
                                            <td>{renderPatientStatus(patient.patient_status)}</td>
                                            <td style={{ color: "blue", width: "1%" }}>
                                                <Popup trigger={<u style={{ cursor: 'pointer' }}>View</u>} position="top center">
                                                    <div style={{ font: 'small-caption' }}>
                                                        <b>Mobile No: {patient.patient_mobileno}</b><br />
                                                        <b>Alt Ph.No: {patient.patient_alternative_mobileno}</b><br />
                                                        <b>Address: {patient.patient_address}</b><br />
                                                        <b>Blood Group: {patient.patient_blood_group}</b>
                                                    </div>
                                                </Popup>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <Pagination
                                className="pagination-data"
                                total={dashboardLeadfromLeads.length}
                                current={dlcurrent}
                                pageSize={dlsize}
                                onChange={dlPaginationChange}
                                showSizeChanger={false} // Only shows prev/next and page numbers
                                showTitle={false}
                                itemRender={dlPrevNextArrow}
                                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                            />
                        </div>
                    </Card>
                )}
            </div>
        );
    };

    return (
        <div className="full_frame_center">
            <div style={{ background: "gainsboro", padding: "5px", margin: "5px" }}>
                <div className="start_center" style={{ width: "100%" }}>
                    <Card style={{ background: "#f7f7f7", margin: "5px", borderRadius: "10px", width: "100%" }}>

                        <Card className="rounded-top text-white d-flex flex-row" style={{ backgroundColor: '#ffffff' }}>
                            <div style={{ width: "100%", color: "#04043c", padding: "15px" }}>
                                <MDBTypography tag="h5" className="d-flex fw-normal mb-0"><u>INFANT Employee Daily Attendance & Work updates</u></MDBTypography>
                            </div>
                        </Card>
                        <div className="end_start" style={{ width: "100%", flexDirection: "row" }}>
                            <div className="start_start" style={{ width: "50%", flexDirection: "row" }}>
                                <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                    <label htmlFor="hospital_type" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>
                                        Hospital Type<b style={{ color: "red" }}>*</b></label>
                                    <Form.Select aria-label="Default select example" name="hospital_type" value={masterdata.hospital_type}
                                        onChange={(event) => handleChangeHospitaltypes(event, "hspttype")} style={{ fontSize: "12px", width: "100%", padding: "6px" }} >
                                        <option value="">SELECT</option>
                                        {hospitaltype.map((hospitaltype, index) => (
                                            <option key={index} value={hospitaltype.hospitaltype_name}>{hospitaltype.hospitaltype_name}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                                <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                    <label htmlFor="hospital_code" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>
                                        Hospital Code<b style={{ color: "red" }}>*</b></label>
                                    <Form.Select aria-label="Default select example" name="hospital_code" value={masterdata.hospital_code}
                                        onChange={(event) => handleChangeHospitaltypes(event, "hsptcode")} style={{ fontSize: "12px", width: "100%", padding: "6px" }} >
                                        <option value="">SELECT</option>
                                        {hospitalcode.map((hospitalcode, index) => (
                                            <option key={index} value={hospitalcode.hospitalcode_name}>{hospitalcode.hospitalcode_name}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                                <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                    <label htmlFor="login_staff_details" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>
                                        Employee Name<b style={{ color: "red" }}>*</b></label>
                                    <Form.Select aria-label="Default select example" name="login_staff_details" value={masterdata.login_staff_details}
                                        onChange={(event) => handleChangeHospitaltypes(event, "")} style={{ fontSize: "12px", width: "100%", padding: "6px" }} >
                                        <option value="">SELECT</option>
                                        {staffdata.map((staffdata, index) => (
                                            <option key={index} value={staffdata.hospital_nm + "/" + staffdata.staff_display_nm + "/" + staffdata.login_user_nm + "/" + staffdata.staff_mobile_nu + "/" + staffdata.staff_aadharno + "/"}>{staffdata.staff_display_nm}</option>
                                        ))}
                                    </Form.Select>
                                </div>

                            </div>
                            <div className="start_start" style={{ width: "50%", flexDirection: "row" }}>

                                <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                    <label htmlFor="f_fromdate" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>From Date</label>
                                    <input type="date" name="f_fromdate" value={masterdata.f_fromdate}
                                        style={{ fontSize: "12px", width: "100%", padding: "6px" }} onChange={(event) => handleChangeHospitaltypes(event, "fromdate")} />
                                </div>

                                <div className="start_center" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                    <label htmlFor="f_todate" className='text-controol' style={{ width: "100%", fontSize: "13px", color: "green" }}>To Date</label>
                                    <input type="date" name="f_todate" value={masterdata.f_todate}
                                        style={{ fontSize: "12px", width: "100%", padding: "6px" }} onChange={(event) => handleChangeHospitaltypes(event, "todate")} />
                                </div>

                                <div className="start_start" style={{ width: "100%", padding: "10px", flexDirection: "column" }}>
                                    <label htmlFor="getdata" className='text-controol' style={{ color: "#190262", fontSize: "12px", fontWeight: "bold" }}>
                                        Get</label>
                                    <button className="btn btn-primary" style={{
                                        background: "#190262", borderColor: "#190262", color: "#ffffff",
                                        fontSize: "12px"
                                    }} onClick={getData} >GET</button>
                                </div>

                            </div>
                        </div>



                        <MDBCardBody className="text-black ">
                            <div className="mb-1">
                                <div className="ms-4" style={{ color: "#04043c" }}>
                                    <MDBCardText className=" d-flex fw-normal mt-1 mb-0 small " ><b style={{ marginRight: "5px" }}>Name</b> :- <b>{login_staff_display_nm} ( {staffuniqueid} ) </b></MDBCardText>
                                    <MDBCardText className=" d-flex fw-normal mt-1 mb-0 small " ><b style={{ marginRight: "5px" }}>Ph.No</b> :- <b>( {pnumchars} )</b></MDBCardText>
                                    <MDBCardText className=" d-flex fw-normal mt-1 mb-0 small " ><b style={{ marginRight: "5px" }}>Work place</b> :- <b>( {login_work_place} )</b></MDBCardText>

                                    <MDBCardText className=" d-flex fw-normal mt-3 mb-1 small " >
                                        <u style={{ color: "green" }}>Dates count : <b style={{ color: "red", marginLeft: "10px" }}> {dateList.length} </b></u>
                                    </MDBCardText>


                                    <MDBRow className="justify-content-center align-items-center h-100" style={{ width: "100%" }}>

                                        <MDBCol style={{ width: "100%" }}>
                                            <MDBCard style={{ width: "100%" }}>


                                                <Card className="start_center" style={{ backgroundColor: '#ffffff', fontSize: "14px", width: "100%" }}>
                                                    <div className="d-flex fw-normal ms-4 mt-2 mb-2 " style={{ color: "#04043c", width: "100%" }}>
                                                        <MDBTypography className="d-flex fw-normal mb-0" style={{ width: "50%" }}>
                                                            <b style={{ width: "100%" }}> Date </b>
                                                        </MDBTypography>

                                                        <MDBTypography className="d-flex fw-normal mb-0" style={{ width: "50%" }}>
                                                            <b style={{ width: "100%" }}> Attendance </b>
                                                        </MDBTypography>

                                                        <MDBTypography className="d-flex fw-normal mb-0" style={{ width: "100%" }}>
                                                            <b style={{ width: "100%" }}> Work update </b>
                                                        </MDBTypography>

                                                        <MDBTypography className="d-flex fw-normal mb-0" style={{ width: "50%" }}>
                                                            <b style={{ width: "100%" }}> Delivery Entries </b>
                                                        </MDBTypography>

                                                        <MDBTypography className="d-flex fw-normal mb-0" style={{ width: "50%" }}>
                                                            <b style={{ width: "100%" }}> Discharged Entries </b>
                                                        </MDBTypography>

                                                    </div>
                                                </Card>



                                            </MDBCard>
                                        </MDBCol>

                                    </MDBRow>



                                    <MDBCardText  >
                                        {loading ? (
                                            <div className="center_center" style={{ width: "100%", display: "flex" }}>
                                                <RotatingLines width="50px" height="50px" strokeColor="red" strokeWidth="8"
                                                    animationDuration="0.75" visible={true} />
                                            </div>
                                        ) : (

                                            <div style={{ width: "100%", flexDirection: "column", display: "flex" }}>
                                                <ImageList className="start_center" style={{ width: "100%" }}>
                                                    {dateList.map((report_responce, index) => (
                                                        <MDBRow key={index} className="justify-content-center align-items-center h-100" style={{ width: "100%" }}>
                                                            <MDBCol style={{ width: "100%" }}>
                                                                <MDBCard style={{ width: "100%" }}>
                                                                    <Card className="start_center" style={{ backgroundColor: '#ffffff', fontSize: "14px", width: "100%" }}>
                                                                        <div className="d-flex fw-normal ms-4 mt-2 mb-2" style={{ color: "#04043c", width: "100%" }}>
                                                                            <MDBTypography className="d-flex fw-normal mb-0" style={{ width: "50%" }}>
                                                                                <b style={{ width: "100%" }}><u>{report_responce.dateval} : </u></b>
                                                                            </MDBTypography>

                                                                            <MDBCardText className="d-flex fw-normal mt-1 mb-0" style={{ width: "50%" }}>
                                                                                {attendancedata.map((report_att, attIndex) => (
                                                                                    report_att.wrk_dt === report_responce.dateval && (
                                                                                        <div key={attIndex} className="mt-2 mb-2" style={{ color: "#04043c", width: "100%" }}>
                                                                                            <MDBTypography className="d-flex fw-normal mb-0 small">
                                                                                                <b style={{ marginRight: "5px", color: "#007bff" }}>In time </b> :
                                                                                                <b style={{ color: "red", marginRight: "5px", marginLeft: "5px" }}>{report_att.in_time}</b>
                                                                                            </MDBTypography>
                                                                                            <MDBCardText className="d-flex fw-normal mt-0 mb-0 small" style={{ color: "#007bff" }}>
                                                                                                <b style={{ marginRight: "5px", color: "#007bff" }}>Out time </b> :
                                                                                                <b style={{ color: "red", marginLeft: "5px" }}>{report_att.out_time}</b>
                                                                                            </MDBCardText>
                                                                                        </div>
                                                                                    )
                                                                                ))}
                                                                            </MDBCardText>

                                                                            <MDBCardText className="mt-1 mb-0" style={{ width: "100%" }}>
                                                                                {workupdatedata.map((report_workst, workIndex) => (
                                                                                    report_workst.report_date === report_responce.dateval && (
                                                                                        <div key={workIndex} className="mt-2 mb-2" style={{ color: "#04043c", width: "100%" }}>
                                                                                            <MDBTypography className="d-flex fw-normal mb-0 small">
                                                                                                <b style={{ width: "100%" }}>{report_workst.sts_tm}</b>
                                                                                            </MDBTypography>
                                                                                            <MDBCardText className="d-flex fw-normal mt-0 mb-0 small" style={{ color: "#007bff" }}>
                                                                                                <b>{report_workst.sts_desc_tx}</b>
                                                                                            </MDBCardText>
                                                                                        </div>
                                                                                    )
                                                                                ))}
                                                                            </MDBCardText>

                                                                            <MDBCardText className="d-flex fw-normal mt-1 mb-0" style={{ width: "50%" }}>
                                                                                <JoiningPatients patientsdata={deliverypatients} report_dateval={report_responce.dateval} report_type="deliveries" />
                                                                            </MDBCardText>

                                                                            <MDBCardText className="d-flex fw-normal mt-1 mb-0" style={{ width: "50%" }}>
                                                                                <JoiningPatients patientsdata={dischargedpatients} report_dateval={report_responce.dateval} report_type="discharges" />
                                                                            </MDBCardText>
                                                                        </div>
                                                                    </Card>
                                                                </MDBCard>
                                                            </MDBCol>
                                                        </MDBRow>
                                                    ))}
                                                </ImageList>
                                            </div>
                                        )}
                                    </MDBCardText>

                                    <div style={{ borderTop: "2px solid #dfe3e7 ", marginBottom: "10px" }}></div>
                                    {(() => {
                                        if (leadsfromdataView === "NO") {
                                            return (
                                                <></>
                                            )
                                        } else if (leadsfromdataView === "YES") {
                                            return (
                                                <DashboardBranchwiseLeadsfromData />
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                        </MDBCardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default EmployeeWorkDetails;
